import { PageMeta, JsonLd } from '@/components/feature/Head';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotArticles from './components/HotArticles';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  return (
    <>
      <PageMeta
        title="国产区精选内容聚合平台 - 汇聚海量优质国产原创内容"
        description="国产区汇聚海量优质国产原创内容，为用户提供最全面的国产区资源导航与分类推荐。探索国产区精品内容，发现更多本土创作精华，一站式满足您对国产区内容的全部需求。"
        keywords="国产区,国产区精选,国产区资源,国产区内容推荐,国产区原创,国产区分类导航,国产区合集"
        canonical="https://guochanqu.com"
        ogTitle="国产区精选内容聚合平台 - 汇聚海量优质国产原创内容"
        ogDescription="国产区汇聚海量优质国产原创内容，为用户提供最全面的国产区资源导航与分类推荐。"
        ogUrl="https://guochanqu.com"
        ogType="website"
      />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '国产区精选内容聚合平台 - 首页',
          description: '国产区汇聚海量优质国产原创内容，为用户提供最全面的国产区资源导航与分类推荐。',
          url: 'https://guochanqu.com',
          isPartOf: {
            '@type': 'WebSite',
            name: '国产区精选内容聚合平台',
            url: 'https://guochanqu.com',
          },
        }}
      />

      <main>
        <HeroSection />
        <CategoryGrid />
        <HotArticles />
        <LatestArticles />

        <section className="py-14 md:py-20 bg-foreground-950">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
              加入国产区内容生态
            </h2>
            <p className="text-sm text-background-50/60 max-w-2xl mx-auto mb-8 leading-relaxed">
              国产区致力于打造最优质的国产原创内容聚合平台。无论您是内容创作者还是内容消费者，
              这里都有一片属于您的天地。一起发现、分享、传播国产原创的力量。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="/category/film-tv"
                className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line mr-2"></i>
                浏览内容
              </a>
              <a
                href="/about"
                className="w-full sm:w-auto px-8 py-3 rounded-lg border border-background-50/20 text-background-50 text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                关于我们
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}